// Color palette for consistent visualizations
const COLOR_PALETTE = {
  gold: '#FFD700',
  skyBlue: '#87CEEB',
  paleGreen: '#98FB98',
  salmon: '#FFA07A',
  plum: '#DDA0DD',
  lemonChiffon: '#FFFACD',
  lavender: '#E6E6FA',
  mistyRose: '#FFE4E1',
  aliceBlue: '#F0F8FF',
  honeydew: '#F0FFF0',
  beige: '#F5F5DC'
};

// 1. Word Position Coloring
export const getPositionColor = (word, index) => {
  const colors = [
    COLOR_PALETTE.gold,
    COLOR_PALETTE.skyBlue,
    COLOR_PALETTE.paleGreen,
    COLOR_PALETTE.salmon,
    COLOR_PALETTE.plum
  ];
  return colors[index % colors.length];
};
export const getEndingPatternStyle = (word, allWords) => {
  // Remove tashkeel (diacritics) from the ending before comparison
  const endinglength = 2;
  const ending = removeTashkeel(word).slice(-1 * endinglength);
  const sameEnding = allWords.filter(w => removeTashkeel(w).slice(-1 * endinglength) === ending);

  if (sameEnding.length >= 2) {
    const color = stringToColor(ending); // Dynamically generate color
    // console.log({ ending, sameEnding, len: ending.length });

    return {
      color: color,
      // borderBottom: `2px solid ${color}`,
      // paddingBottom: '1px'
    };
  }
  return {};
};

// Helper: Removes Arabic diacritics (tashkeel)
function removeTashkeel(text) {
  return text.replace(/[\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E8\u06EA-\u06ED]/g, '');
}



// wordStyles.js
export const getFirstUniqueSequenceStyle = (wordIndex, verseIndex, ayahs) => {
  // Get all words for each verse
  const verseWords = ayahs.map(ayah => ayah.text.split(' ').filter(word => word.length > 0 && word !=="۞"));

  // Current verse's words
  const currentWords = verseWords[verseIndex];

  // Find the length of the unique starting sequence
  let sequenceLength = 1; // Start with at least one word
  for (let len = 1; len <= currentWords.length; len++) {
    const currentSequence = currentWords.slice(0, len).join(' ');
    // Check if any other verse starts with this sequence
    const isUnique = !verseWords.some((words, idx) => {
      if (idx === verseIndex) return false; // Skip current verse
      return words.slice(0, len).join(' ') === currentSequence;
    });
    if (isUnique) {
      sequenceLength = len;
      break;
    }
    // If we reach the end and it's not unique, use the whole verse
    if (len === currentWords.length) {
      sequenceLength = len;
    }
  }

  // Apply red color to all words in the unique sequence
  if (wordIndex < sequenceLength) {
    return {
      color: 'red',
    };
  }
  return {};
};

export const getFirstWordStyle = (wordIndex) => {
  if (wordIndex === 0) {
    return {
      color: 'red',
    };
  }
  return {};
};
// export const getFirstWordStyle = (wordIndex) => {
//   if (wordIndex === 0) {
//     return {
//       color: 'red',
//     };
//   }
//   return {};
// };
// Helper: Generates a deterministic color from a string (HSL-based)
function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 80%, 50%)`;
}
// 3. Root Word Coloring
export const getRootColor = (word) => {
  // Simplified root detection - in practice use a proper dictionary

  const rootMap = {
    'ٱللَّهُ': "red",
    'وَٱللَّهُ': "red",
    'ٱللَّهِ': "red",
    'رَّبِّهِ': "red",
    'رَبُّكَ': "red",
    'عَلِيمٌۭ': "green",
    'ٱلْحَكِيمُ': "green",
  };

  // Check if word contains any root
  for (const root in rootMap) {
    if (word.includes(root)) {
      return rootMap[root];
    }
  }
  return null;
};
